const initialState = { isLoading: true, banners: [], requestMake: false };
export const FETCH_BANNERS = 'FETCH_BANNERS';
export const FETCH_BANNERS_SUCCESS = `${FETCH_BANNERS}_SUCCESS`;
export const FETCH_BANNERS_FAIL = `${FETCH_BANNERS}_FAIL`;

const BannersReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_BANNERS:
      return { ...state, isLoading: true, requestMake: true };
    case FETCH_BANNERS_SUCCESS:
      return { ...state, isLoading: false, banners: action.payload.data };
    case FETCH_BANNERS_FAIL:
      return { ...state, isLoading: false, error: action.error };
    default:
      return { ...state };
  }
};

export default BannersReducer;
